module.exports = __webpack_public_path__ + "img/1516525942.44bf3d54.jpg";